// extracted by mini-css-extract-plugin
export default {"posterCtn":"poster_posterCtn__yEBFu","detailCtn":"poster_detailCtn__EwvWQ","posterImgCtn":"poster_posterImgCtn__tjHsE","ctn":"poster_ctn__z2shC"};